var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404Img(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 347.59,
    height: 337.75,
    viewBox: "0 0 347.59 337.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_404_Error-rafiki",
    "data-name": "404 Error-rafiki",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--404--inject-14",
    transform: "translate(14.968 118.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10352",
    "data-name": "Path 10352",
    d: "M146.829,286.244h-60V259.158l60-71.328h28.713V260.7h14.879v25.548H175.542V308.41H146.829Zm0-25.548V223.386L115.119,260.7Z",
    transform: "translate(-86.83 -187.81)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10353",
    "data-name": "Path 10353",
    d: "M202.3,248.647q0-33.81,12.167-47.329t37.084-13.508q11.96,0,19.651,2.958a36.275,36.275,0,0,1,12.532,7.681,41.011,41.011,0,0,1,7.642,9.949,51.647,51.647,0,0,1,4.486,12.167,113.745,113.745,0,0,1,3.313,27.608q0,32.262-10.915,47.22t-37.6,14.968q-14.968,0-24.187-4.772A39.2,39.2,0,0,1,211.361,291.6q-4.289-6.547-6.675-17.916A122.6,122.6,0,0,1,202.3,248.647Zm32.677.079q0,22.678,3.993,30.931t11.605,8.292a12.167,12.167,0,0,0,8.7-3.52q3.688-3.52,5.423-11.122t1.735-23.664q0-23.605-4-31.74t-12.01-8.125q-8.164,0-11.832,8.292T234.976,248.726Z",
    transform: "translate(-88.445 -187.81)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10354",
    "data-name": "Path 10354",
    d: "M370.889,286.244h-60V259.158l60-71.328H399.6V260.7H414.53v25.548H399.6V308.41H370.889Zm0-25.548V223.386l-31.7,37.311Z",
    transform: "translate(-89.963 -187.81)",
    fill: "#0075e9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Planets--inject-14",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57824",
    "data-name": "Group 57824",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10355",
    "data-name": "Path 10355",
    d: "M200.948,145.594a1.834,1.834,0,1,1-.534-1.3A1.844,1.844,0,0,1,200.948,145.594Z",
    transform: "translate(-73.407 -68.744)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_752",
    "data-name": "Ellipse 752",
    cx: 1.302,
    cy: 1.302,
    r: 1.302,
    transform: "translate(0 145.073)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_753",
    "data-name": "Ellipse 753",
    cx: 1.864,
    cy: 1.864,
    r: 1.864,
    transform: "translate(214.468 334.023)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_754",
    "data-name": "Ellipse 754",
    cx: 1.302,
    cy: 1.302,
    r: 1.302,
    transform: "translate(259.845 259.322)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10356",
    "data-name": "Path 10356",
    d: "M424.133,95.6a1.3,1.3,0,1,1-1.3-1.3A1.3,1.3,0,0,1,424.133,95.6Z",
    transform: "translate(-76.543 -68.052)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10357",
    "data-name": "Path 10357",
    d: "M172.713,68.982a1.3,1.3,0,1,1-1.3-1.3,1.3,1.3,0,0,1,1.3,1.3Z",
    transform: "translate(-73.027 -67.68)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_755",
    "data-name": "Ellipse 755",
    cx: 1.302,
    cy: 1.302,
    r: 1.302,
    transform: "translate(201.867 66.99)",
    fill: "#0075e9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_756",
    "data-name": "Ellipse 756",
    cx: 21.604,
    cy: 21.604,
    r: 21.604,
    transform: "translate(47.003 26.396)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_757",
    "data-name": "Ellipse 757",
    cx: 21.604,
    cy: 21.604,
    r: 21.604,
    transform: "translate(47.003 26.396)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10358",
    "data-name": "Path 10358",
    d: "M133.479,99.83a21.535,21.535,0,0,0-8.559,1.745,21.613,21.613,0,0,0,24.522,34.4h0a21.613,21.613,0,0,0-16-36.137Z",
    transform: "translate(-72.316 -68.13)",
    fill: "#0075e9",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10359",
    "data-name": "Path 10359",
    d: "M131.444,105.592a1.972,1.972,0,1,1-1.972-1.972A1.972,1.972,0,0,1,131.444,105.592Z",
    transform: "translate(-72.431 -68.183)",
    fill: "#0075e9",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10360",
    "data-name": "Path 10360",
    d: "M155,103.592a1.972,1.972,0,1,1-1.972-1.972A1.972,1.972,0,0,1,155,103.592Z",
    transform: "translate(-72.76 -68.155)",
    fill: "#0075e9",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10361",
    "data-name": "Path 10361",
    d: "M150.968,117.854a3.234,3.234,0,1,1-3.234-3.234A3.234,3.234,0,0,1,150.968,117.854Z",
    transform: "translate(-72.669 -68.336)",
    fill: "#0075e9",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10362",
    "data-name": "Path 10362",
    d: "M140.518,127.189a4.319,4.319,0,1,1-4.319-4.319,4.319,4.319,0,0,1,4.319,4.319Z",
    transform: "translate(-72.492 -68.452)",
    fill: "#0075e9",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_758",
    "data-name": "Ellipse 758",
    cx: 18.961,
    cy: 18.961,
    rx: 18.961,
    ry: 18.961,
    transform: "translate(283.382 318.332) rotate(-76.72)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_759",
    "data-name": "Ellipse 759",
    cx: 18.961,
    cy: 18.961,
    rx: 18.961,
    ry: 18.961,
    transform: "translate(283.382 318.332) rotate(-76.72)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10363",
    "data-name": "Path 10363",
    d: "M393.984,361.328a18.951,18.951,0,0,0-17.423,32.854,18.736,18.736,0,0,0,5.453.809,18.961,18.961,0,0,0,11.97-33.663Z",
    transform: "translate(-75.816 -71.775)",
    fill: "#0075e9",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10364",
    "data-name": "Path 10364",
    d: "M363.7,381.832c-20.243,9.525-5.147,16.871,23.378,6.616,26.415-9.5,36.483-21.466,12.818-17.748C401.167,375.68,368.086,388.567,363.7,381.832Z",
    transform: "translate(-75.604 -71.908)",
    fill: "#0075e9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Astronaut--inject-14",
    transform: "translate(134.275 12.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10365",
    "data-name": "Path 10365",
    d: "M393.074,187.83c-26.514,17.916-60.837,41.58-70.313,98.414H320.74c9.219-56.2,42.29-80.429,68.814-98.414Z",
    transform: "translate(-209.408 -81.928)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10366",
    "data-name": "Path 10366",
    d: "M254.34,364.793c-16.762,0-33.337-7.563-41.413-19.908-4.979-7.632-10.767-23.615,6.468-44.943l1.528,1.242c-12.187,15.086-14.435,30.221-6.34,42.625,9.86,15.086,33.12,22.678,52.979,17.275,20.342-5.532,32.686-23.221,33.88-48.532,4.072-86.582,50.07-113.254,83.654-132.728,20.874-12.1,35.95-20.835,32.637-39.283a7.666,7.666,0,0,0-3.126-5.4c-4.289-2.83-12.67-.868-22.373,1.39-19.04,4.437-45.11,10.511-60.64-15.9l1.706-.986c14.79,25.173,39.017,19.523,58.491,14.987,10.146-2.357,18.9-4.4,23.9-1.114,2.12,1.39,3.421,3.589,3.944,6.7,3.56,19.8-12.818,29.3-33.574,41.334-33.2,19.247-78.654,45.6-82.677,131.14-1.242,26.228-14.12,44.578-35.339,50.346A52.139,52.139,0,0,1,254.34,364.793Z",
    transform: "translate(-207.829 -80.975)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10367",
    "data-name": "Path 10367",
    d: "M254.34,364.793c-16.762,0-33.337-7.563-41.413-19.908-4.979-7.632-10.767-23.615,6.468-44.943l1.528,1.242c-12.187,15.086-14.435,30.221-6.34,42.625,9.86,15.086,33.12,22.678,52.979,17.275,20.342-5.532,32.686-23.221,33.88-48.532,4.072-86.582,50.07-113.254,83.654-132.728,20.874-12.1,35.95-20.835,32.637-39.283a7.666,7.666,0,0,0-3.126-5.4c-4.289-2.83-12.67-.868-22.373,1.39-19.04,4.437-45.11,10.511-60.64-15.9l1.706-.986c14.79,25.173,39.017,19.523,58.491,14.987,10.146-2.357,18.9-4.4,23.9-1.114,2.12,1.39,3.421,3.589,3.944,6.7,3.56,19.8-12.818,29.3-33.574,41.334-33.2,19.247-78.654,45.6-82.677,131.14-1.242,26.228-14.12,44.578-35.339,50.346A52.139,52.139,0,0,1,254.34,364.793Z",
    transform: "translate(-207.829 -80.975)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10368",
    "data-name": "Path 10368",
    d: "M312.76,97a45.407,45.407,0,0,1,13.39,2.1S337,117.608,338.278,121.848c-.454,4.181-7.5,11.034-7.5,11.034Z",
    transform: "translate(-209.297 -80.658)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10369",
    "data-name": "Path 10369",
    d: "M312.76,97a45.407,45.407,0,0,1,13.39,2.1S337,117.608,338.278,121.848c-.454,4.181-7.5,11.034-7.5,11.034Z",
    transform: "translate(-209.297 -80.658)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10370",
    "data-name": "Path 10370",
    d: "M344.866,187.316a139.447,139.447,0,0,1-11.4-16.151q-1.242-2.14-2.357-4.358c-.424-.838-.828-1.676-1.223-2.524a10.608,10.608,0,0,1-1.193-2.652c-1.183-12.493,3.1-21.692-.986-31.72l-16.25,6.35s1.38,17.867,4.536,28.594c1.972,6.636,6.389,12.374,10.659,17.689,1.331,1.656,2.613,3.362,3.944,5.029s2.672,3.017,3.944,4.585c1.923,2.376,2.554,4.654,1.1,7.454l-.246.444c-.414.73,1.518,1.558,2.741,0,1.972-2.544,1.7-2.386,3.412-4.555,1.045-1.311,2.238-2.741,3.274-3.944A3.323,3.323,0,0,0,344.866,187.316Z",
    transform: "translate(-209.278 -81.118)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10371",
    "data-name": "Path 10371",
    d: "M344.866,187.316a139.447,139.447,0,0,1-11.4-16.151q-1.242-2.14-2.357-4.358c-.424-.838-.828-1.676-1.223-2.524a10.608,10.608,0,0,1-1.193-2.652c-1.183-12.493,3.1-21.692-.986-31.72l-16.25,6.35s1.38,17.867,4.536,28.594c1.972,6.636,6.389,12.374,10.659,17.689,1.331,1.656,2.613,3.362,3.944,5.029s2.672,3.017,3.944,4.585c1.923,2.376,2.554,4.654,1.1,7.454l-.246.444c-.414.73,1.518,1.558,2.741,0,1.972-2.544,1.7-2.386,3.412-4.555,1.045-1.311,2.238-2.741,3.274-3.944A3.323,3.323,0,0,0,344.866,187.316Z",
    transform: "translate(-209.278 -81.118)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10372",
    "data-name": "Path 10372",
    d: "M341.189,182.92a53.93,53.93,0,0,1-8.539,7.415c.424.473.838.986,1.262,1.44a43.3,43.3,0,0,0,8.381-7.4Z",
    transform: "translate(-209.575 -81.86)",
    fill: "#0075e9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10373",
    "data-name": "Path 10373",
    d: "M345.32,188.128l-.118-.138a5.108,5.108,0,0,0-1.252,3.126,4.929,4.929,0,0,0,.375,2.317l.937-1.114a3.323,3.323,0,0,0,.059-4.191Z",
    transform: "translate(-209.733 -81.931)",
    fill: "#0075e9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10374",
    "data-name": "Path 10374",
    d: "M308.374,108.894a34.885,34.885,0,0,1-6.281,7.089,22.945,22.945,0,0,1-4.358,2.958,18.728,18.728,0,0,1-2.544,1.075l-.67.217-.217.059-.463.128a5.849,5.849,0,0,1-.868.138,7.445,7.445,0,0,1-2.475-.227,12.068,12.068,0,0,1-2.9-1.252,24.659,24.659,0,0,1-2.12-1.39,39.747,39.747,0,0,1-3.53-2.958,52.419,52.419,0,0,1-5.916-6.646,2.475,2.475,0,0,1,3.3-3.569h.079c2.327,1.479,4.674,3.037,6.961,4.427,1.163.68,2.288,1.371,3.4,1.9a15.074,15.074,0,0,0,1.568.71,3.077,3.077,0,0,0,1.055.256c.059,0,0-.069-.365-.059a2.9,2.9,0,0,0-.345,0l-.217.049h0l.325-.168a13.341,13.341,0,0,0,1.272-.779,18.141,18.141,0,0,0,2.465-2.09,62.738,62.738,0,0,0,4.831-5.709h0a4.93,4.93,0,0,1,7.888,5.847Z",
    transform: "translate(-208.776 -80.72)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10375",
    "data-name": "Path 10375",
    d: "M308.374,108.894a34.885,34.885,0,0,1-6.281,7.089,22.945,22.945,0,0,1-4.358,2.958,18.728,18.728,0,0,1-2.544,1.075l-.67.217-.217.059-.463.128a5.849,5.849,0,0,1-.868.138,7.445,7.445,0,0,1-2.475-.227,12.068,12.068,0,0,1-2.9-1.252,24.659,24.659,0,0,1-2.12-1.39,39.747,39.747,0,0,1-3.53-2.958,52.419,52.419,0,0,1-5.916-6.646,2.475,2.475,0,0,1,3.3-3.569h.079c2.327,1.479,4.674,3.037,6.961,4.427,1.163.68,2.288,1.371,3.4,1.9a15.074,15.074,0,0,0,1.568.71,3.077,3.077,0,0,0,1.055.256c.059,0,0-.069-.365-.059a2.9,2.9,0,0,0-.345,0l-.217.049h0l.325-.168a13.341,13.341,0,0,0,1.272-.779,18.141,18.141,0,0,0,2.465-2.09,62.738,62.738,0,0,0,4.831-5.709h0a4.93,4.93,0,0,1,7.888,5.847Z",
    transform: "translate(-208.776 -80.72)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10376",
    "data-name": "Path 10376",
    d: "M272.287,102.37l1.154,1.972s.878,2.583,2.642,3.057l4.792-1.548-.246-.4h0c-.611-.927-.542-2.731-.335-4.23s-.562-1.548-1.134-1.173a3.767,3.767,0,0,0-.828,1.627,7.654,7.654,0,0,0-.779-.917l-1.459-1.459a1.7,1.7,0,0,0-2.307-.059l-1.183,1.055a1.686,1.686,0,0,0-.316,2.08Z",
    transform: "translate(-208.727 -80.683)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10377",
    "data-name": "Path 10377",
    d: "M272.287,102.37l1.154,1.972s.878,2.583,2.642,3.057l4.792-1.548-.246-.4h0c-.611-.927-.542-2.731-.335-4.23s-.562-1.548-1.134-1.173a3.767,3.767,0,0,0-.828,1.627,7.654,7.654,0,0,0-.779-.917l-1.459-1.459a1.7,1.7,0,0,0-2.307-.059l-1.183,1.055a1.686,1.686,0,0,0-.316,2.08Z",
    transform: "translate(-208.727 -80.683)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10378",
    "data-name": "Path 10378",
    d: "M317.427,95.218A58.806,58.806,0,0,0,302.3,101.6a4.26,4.26,0,0,0-1.913,4.467c1.9,9.308,6.232,21.771,10.905,29.709l21.8-9.022c.148-3.845-5.147-16.289-10.541-28.318C321.588,96.273,319.725,94.666,317.427,95.218Z",
    transform: "translate(-209.122 -80.632)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10379",
    "data-name": "Path 10379",
    d: "M317.427,95.218A58.806,58.806,0,0,0,302.3,101.6a4.26,4.26,0,0,0-1.913,4.467c1.9,9.308,6.232,21.771,10.905,29.709l21.8-9.022c.148-3.845-5.147-16.289-10.541-28.318C321.588,96.273,319.725,94.666,317.427,95.218Z",
    transform: "translate(-209.122 -80.632)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10380",
    "data-name": "Path 10380",
    d: "M326.239,106.189l-4.329-1.449c.986,2.534,4.467,5.739,6.9,7.622C328.023,110.39,327.146,108.319,326.239,106.189Z",
    transform: "translate(-209.425 -80.766)",
    fill: "#0075e9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10381",
    "data-name": "Path 10381",
    d: "M315.973,85.252c-1.8-3.431-5.7-5.157-10.373-4.772-3.944.335-7.435,4.358-7.02,6.527s3.727,3.1,4.358,3.845l-2.731,1.972a2.958,2.958,0,0,0-.592,4.23c1.154,1.459,2.672,2.958,3.55,4.062,7.553-.2,13.144-3.076,15.165-5.847C317.57,91.759,317.728,88.663,315.973,85.252Z",
    transform: "translate(-209.098 -80.426)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10382",
    "data-name": "Path 10382",
    d: "M315.973,85.252c-1.8-3.431-5.7-5.157-10.373-4.772-3.944.335-7.435,4.358-7.02,6.527s3.727,3.1,4.358,3.845l-2.731,1.972a2.958,2.958,0,0,0-.592,4.23c1.154,1.459,2.672,2.958,3.55,4.062,7.553-.2,13.144-3.076,15.165-5.847C317.57,91.759,317.728,88.663,315.973,85.252Z",
    transform: "translate(-209.098 -80.426)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10383",
    "data-name": "Path 10383",
    d: "M312.255,87.413a7.464,7.464,0,1,1-9.673-4.24,7.464,7.464,0,0,1,9.673,4.24Z",
    transform: "translate(-209.088 -80.458)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10384",
    "data-name": "Path 10384",
    d: "M376.565,176.9c-.108-3.244-.256-2.958-.345-5.689-.059-1.676-.069-3.54-.079-5.147a3.313,3.313,0,0,0-2.662-3.234c-1.3-.266-2.613-.513-3.944-.789-1.706-.365-3.392-.759-5.058-1.242-1.3-.375-2.583-.789-3.855-1.252s-2.7-.986-4.023-1.6c-1.558-.661-3.1-1.371-4.615-2.11-1.706-.809-3.392-1.656-5.078-2.514-6.488-10.738-6.626-17.817-13.587-26.12l-14.948,6.764s10.984,19.484,18.458,27.746c4.309,4.753,11.063,6.9,17.088,8.46,4.348,1.114,8.756,1.972,13.163,2.79,1.716.316,3.579.434,5.058,1.459a5.66,5.66,0,0,1,2.11,3.4q.1.414.177.828C374.612,179.479,376.634,178.848,376.565,176.9Z",
    transform: "translate(-209.375 -81.08)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10385",
    "data-name": "Path 10385",
    d: "M376.565,176.9c-.108-3.244-.256-2.958-.345-5.689-.059-1.676-.069-3.54-.079-5.147a3.313,3.313,0,0,0-2.662-3.234c-1.3-.266-2.613-.513-3.944-.789-1.706-.365-3.392-.759-5.058-1.242-1.3-.375-2.583-.789-3.855-1.252s-2.7-.986-4.023-1.6c-1.558-.661-3.1-1.371-4.615-2.11-1.706-.809-3.392-1.656-5.078-2.514-6.488-10.738-6.626-17.817-13.587-26.12l-14.948,6.764s10.984,19.484,18.458,27.746c4.309,4.753,11.063,6.9,17.088,8.46,4.348,1.114,8.756,1.972,13.163,2.79,1.716.316,3.579.434,5.058,1.459a5.66,5.66,0,0,1,2.11,3.4q.1.414.177.828C374.612,179.479,376.634,178.848,376.565,176.9Z",
    transform: "translate(-209.375 -81.08)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10386",
    "data-name": "Path 10386",
    d: "M369.644,162.394c-.592-.128-1.183-.256-1.785-.4.049,3.412-1.548,9.288-2.13,11.073l1.873.355a37.574,37.574,0,0,0,2.041-11.024Z",
    transform: "translate(-210.037 -81.567)",
    fill: "#0075e9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10387",
    "data-name": "Path 10387",
    d: "M376.948,166.561a3.313,3.313,0,0,0-2.652-3.234l-.986-.187A4.516,4.516,0,0,0,374.917,166a5.019,5.019,0,0,0,1.972,1.124A1.789,1.789,0,0,0,376.948,166.561Z",
    transform: "translate(-210.143 -81.583)",
    fill: "#0075e9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10388",
    "data-name": "Path 10388",
    d: "M310.949,87.487c.394,1.5-1.282,3.067-2.613,1.775a30.394,30.394,0,0,0-4.062-3.638c-1.371-.858.454-2.357,2.613-1.775a5.857,5.857,0,0,1,4.062,3.638Z",
    transform: "translate(-209.171 -80.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10389",
    "data-name": "Path 10389",
    d: "M311.157,135.722c-.69.256.572,1.44.572,1.44s13.8-4.723,22.185-9.584a1.854,1.854,0,0,0-.671-1.558,212.977,212.977,0,0,1-22.087,9.7Z",
    transform: "translate(-209.271 -81.064)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10390",
    "data-name": "Path 10390",
    d: "M311.157,135.722c-.69.256.572,1.44.572,1.44s13.8-4.723,22.185-9.584a1.854,1.854,0,0,0-.671-1.558,212.977,212.977,0,0,1-22.087,9.7Z",
    transform: "translate(-209.271 -81.064)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10391",
    "data-name": "Path 10391",
    d: "M321.358,94.551c2.721,1.38,5.275,2.83,7.888,4.437,1.272.809,2.534,1.627,3.786,2.514s2.495,1.795,3.747,2.82l.463.385.582.532a12.553,12.553,0,0,1,.986.986c.315.345.582.68.838.986s.532.671.759.986a43.2,43.2,0,0,1,2.544,3.944,58.224,58.224,0,0,1,3.944,8.233,2.485,2.485,0,0,1-4.131,2.583l-.049-.059c-1.972-2.1-3.875-4.309-5.788-6.37s-3.855-4.151-5.463-5.068c-2.238-1.39-4.733-2.781-7.208-4.141l-7.454-4.141h0a4.931,4.931,0,0,1,4.615-8.716Z",
    transform: "translate(-209.316 -80.615)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10392",
    "data-name": "Path 10392",
    d: "M321.358,94.551c2.721,1.38,5.275,2.83,7.888,4.437,1.272.809,2.534,1.627,3.786,2.514s2.495,1.795,3.747,2.82l.463.385.582.532a12.553,12.553,0,0,1,.986.986c.315.345.582.68.838.986s.532.671.759.986a43.2,43.2,0,0,1,2.544,3.944,58.224,58.224,0,0,1,3.944,8.233,2.485,2.485,0,0,1-4.131,2.583l-.049-.059c-1.972-2.1-3.875-4.309-5.788-6.37s-3.855-4.151-5.463-5.068c-2.238-1.39-4.733-2.781-7.208-4.141l-7.454-4.141h0a4.931,4.931,0,0,1,4.615-8.716Z",
    transform: "translate(-209.316 -80.615)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10393",
    "data-name": "Path 10393",
    d: "M349.614,125.662l-.838-2.1s-.463-2.682-2.13-3.431l-4.93.779.168.434h0c.454.986.108,2.79-.335,4.23s.306,1.627.937,1.341c.355-.158.7-.8,1.075-1.479a8.351,8.351,0,0,0,.621.986l1.213,1.666a1.7,1.7,0,0,0,2.268.434l1.341-.858a1.676,1.676,0,0,0,.611-2Z",
    transform: "translate(-209.697 -80.982)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10394",
    "data-name": "Path 10394",
    d: "M349.614,125.662l-.838-2.1s-.463-2.682-2.13-3.431l-4.93.779.168.434h0c.454.986.108,2.79-.335,4.23s.306,1.627.937,1.341c.355-.158.7-.8,1.075-1.479a8.351,8.351,0,0,0,.621.986l1.213,1.666a1.7,1.7,0,0,0,2.268.434l1.341-.858a1.676,1.676,0,0,0,.611-2Z",
    transform: "translate(-209.697 -80.982)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10395",
    "data-name": "Path 10395",
    d: "M317.118,106.06l-1.2.1-7.385,17.827a3.944,3.944,0,0,0,1.2-.1s9.624-3.589,12.532-4.93C320.313,114.924,317.118,106.06,317.118,106.06Z",
    transform: "translate(-209.237 -80.785)",
    fill: "#0075e9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10396",
    "data-name": "Path 10396",
    d: "M303.57,110.735a42.8,42.8,0,0,0,4.93,13.252c3.609-1.242,9.624-3.589,12.542-4.93a133.472,133.472,0,0,1-5.216-12.9C312.74,106.367,305.966,108.96,303.57,110.735Z",
    transform: "translate(-209.168 -80.786)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10397",
    "data-name": "Path 10397",
    d: "M310.929,114.664a2.544,2.544,0,1,1-1.706-3.165,2.544,2.544,0,0,1,1.706,3.165Z",
    transform: "translate(-209.201 -80.859)",
    fill: "#0075e9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10398",
    "data-name": "Path 10398",
    d: "M312.887,111.255a.838.838,0,1,1-.552-.986A.828.828,0,0,1,312.887,111.255Z",
    transform: "translate(-209.275 -80.843)",
    fill: "#0075e9",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10399",
    "data-name": "Path 10399",
    d: "M315.126,110.385a.838.838,0,1,1-1.6-.483.828.828,0,0,1,1.035-.552.838.838,0,0,1,.562,1.035Z",
    transform: "translate(-209.306 -80.83)",
    fill: "#0075e9",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10400",
    "data-name": "Path 10400",
    d: "M318.153,118.165l-9.121,3.6-.542-1.795,9.111-3.6Z",
    transform: "translate(-209.237 -80.929)",
    fill: "#0075e9",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-14",
    transform: "translate(24.253 154.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10401",
    "data-name": "Path 10401",
    d: "M266.558,256.99A92.681,92.681,0,0,1,264.9,274.1q-1.745,7.6-5.423,11.122a12.128,12.128,0,0,1-8.687,3.52q-7.6,0-11.605-8.292a23.452,23.452,0,0,1-1.193-3.066,142.291,142.291,0,0,0-15.7,15.776l-5.236,6.173a38.079,38.079,0,0,0,9.633,7.089q9.209,4.762,24.177,4.772c1.755,0,3.451-.049,5.1-.148a141.385,141.385,0,0,0,14.889-28.594L285.5,244.27Z",
    transform: "translate(-97.936 -224.175)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10402",
    "data-name": "Path 10402",
    d: "M133.39,309.581l17.255,17.255,48.315-45.524C182.306,274.952,149.926,293.006,133.39,309.581Z",
    transform: "translate(-96.766 -224.675)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10403",
    "data-name": "Path 10403",
    d: "M194.175,370.07c-5.512-5.522-17.255-17.255-17.255-17.255L222.444,304.5C228.765,321.114,210.711,353.525,194.175,370.07Z",
    transform: "translate(-97.375 -225.017)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10404",
    "data-name": "Path 10404",
    d: "M259.821,260.185l18.823-36.3-36.3,18.843a142.2,142.2,0,0,0-31.986,22.678L148.49,323.655l30.4,30.4,58.244-61.872a142.2,142.2,0,0,0,22.688-32Z",
    transform: "translate(-96.977 -223.89)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10405",
    "data-name": "Path 10405",
    d: "M259.821,260.185l18.823-36.3-36.3,18.843a142.2,142.2,0,0,0-31.986,22.678L148.49,323.655l30.4,30.4,58.244-61.872a142.2,142.2,0,0,0,22.688-32Z",
    transform: "translate(-96.977 -223.89)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_760",
    "data-name": "Ellipse 760",
    cx: 12.72,
    cy: 12.72,
    r: 12.72,
    transform: "translate(111.472 44.755)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_761",
    "data-name": "Ellipse 761",
    cx: 8.174,
    cy: 8.174,
    r: 8.174,
    transform: "translate(116.018 49.301)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10406",
    "data-name": "Path 10406",
    d: "M189.328,344.073,159.56,314.3l24.374-22.935,28.328,28.338Z",
    transform: "translate(-97.132 -224.834)",
    fill: "#0075e9",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10407",
    "data-name": "Path 10407",
    d: "M139.605,337.62c-22.284,1.8-29.669,16.072-32.193,35.033-1.282,9.673-1.854,19.464-9.969,25.124a2.731,2.731,0,0,0,1.607,4.989c29.916-.937,43.868-15.579,45.623-21.693a42.456,42.456,0,0,1-2.455,9.338,2.721,2.721,0,0,0,3.944,3.343c8.391-5.255,18.922-14.938,19.622-30.645C159.611,354.363,139.605,337.62,139.605,337.62Z",
    transform: "translate(-96.247 -225.48)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10408",
    "data-name": "Path 10408",
    d: "M139.605,337.62c-22.284,1.8-29.669,16.072-32.193,35.033-1.282,9.673-1.854,19.464-9.969,25.124a2.731,2.731,0,0,0,1.607,4.989c29.916-.937,43.868-15.579,45.623-21.693a42.456,42.456,0,0,1-2.455,9.338,2.721,2.721,0,0,0,3.944,3.343c8.391-5.255,18.922-14.938,19.622-30.645C159.611,354.363,139.605,337.62,139.605,337.62Z",
    transform: "translate(-96.247 -225.48)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10409",
    "data-name": "Path 10409",
    d: "M169.774,369.735,134.08,334.042l19.01-4.112,20.8,20.8Z",
    transform: "translate(-96.776 -225.373)",
    fill: "#0075e9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Img);
export default __webpack_public_path__ + "static/media/404-img.67de7a7a3d10b46d2f503faee79504ad.svg";
export { ForwardRef as ReactComponent };